<template>
  <v-card class="px-2 pb-2 mb-3">
    <v-card-title primary-title>
      <span class="title">OpenOrders</span>
    </v-card-title>
    <v-container fluid>
      <v-layout pt-3>
        <v-autocomplete class="ml-0" 
          v-model="selected"
          :options="items"
          :items="items" 
          item-text="name"
          cache-items
          label="Select a sheet"  
        ></v-autocomplete>
        <v-btn 
          color="green" 
          class="ml-3" 
          :loading="loading"
          @click=refreshSheet(selected)
        > Refresh </v-btn> 
        <v-btn 
          color="blue"
          class="ml-3"
          :loading="loading"
          :href="url(selected)"
          target="_blank"
        > View Sheet </v-btn>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MongoConnector from '@/services/mongo-connector.service'
import MessageDialog from '../../libs/message-dialog/'

export default {
    data() {
      const service = new MongoConnector(null, 'spreadsheet-open-order-report-config', {})
      return {
        service,
        loading: false,
        selected: {},
        items: [],
        }
      },
    async beforeMount () {
      this.loading = true
      try {
        let result = await this.service.find({ limit: 100 , sort: { client: 1 }})
        result = result.map(x => {
          return {
            sheet_id: x.spreadsheet_id,
            name: x.client,
            tab_id: 0
          }
        })
        this.items.push(...result)
      } catch (e) { console.log(e) }
      this.loading = false
    }, computed: {
    value() {
      return (item) => {
        return {
          sheet_id: item.sheet_id,
          tab_id: item.tab_id,
          name: item.name
        }
      }
    }
    },
    methods: {
      url (name) {
        if (typeof name === 'string') {
        const matchingItems = this.items.filter(item => item.name === name)
        if (matchingItems.length) {
          return `https://docs.google.com/spreadsheets/d/${matchingItems[0].sheet_id}/view#gid=${matchingItems[0].balance_tab_id}`
        } else {
          MessageDialog.showErrorMessage({ title: name, text: 'This Spreadsheet is not found' })
        }
      }
      },
      async refreshSheet (name) {
        this.loading = true
        if (typeof name === 'string') {
        try {
          const result = await MongoService.spreadsheetOperation.refreshOpenOrders({ client: name })
          console.log('🚀 ~ file: OpenOrders.vue:90 ~ refreshSheet ~ result:', result)
          if (result.statusCode === 200) {
            MessageDialog.showSuccessMessage({ title: name , text: 'Spreadsheet Refresh Complete'})
          } else {
              MessageDialog.showErrorMessage({ title: name, text: result.body })
            }
        } catch (error) {
          console.log(error)
        }
        this.loading = false
    } else {
      MessageDialog.showErrorMessage({ text: 'Please Select Client' })
      this.loading = false
    }
  }
    }
  }
</script>

